import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import dayjs from 'dayjs'

import { api } from '../adminApi'

interface StoreFileBlobEntry {
  blobIdentifier: string
  uploadTimestamp: string
  type: string,
  size: string,
  contentHash: string,
  status: string
}

interface DataTableOptions {
  page: number,
  itemsPerPage: number,
  sortBy: string[],
  sortDesc: boolean[],
  groupBy: string[],
  groupDesc: boolean[],
  multiSort: boolean,
  mustSort: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreFileBlobList',
  props: {
    store: null,
    file: null
  },
  setup(__props: any) {

const props = __props as {
  store: string,
  file: string,
}




const headers = [
  {
    text: "Identifier",
    value: "blobIdentifier",
  },
  {
    text: "Uploaded at",
    value: "uploadTimestamp",
  },
  {
    text: "Type",
    value: "type",
  },
  {
    text: "Size",
    value: "size",
  },
  {
    text: "Content SHA256 Hash",
    value: "contentHash",
  },
  {
    text: "Status",
    value: "status",
  },
  {
    text: "Operations",
    value: "operations",
  },
]

let options: DataTableOptions = {
  page: 1,
  itemsPerPage: 25,
  sortBy: [],
  sortDesc: [],
  groupBy: [],
  groupDesc: [],
  multiSort: false,
  mustSort: false,
}

const storeFileBlobs = ref([] as StoreFileBlobEntry[])
const total = ref(1)

function translateBlobType(blobType: string | undefined): string {
  if (blobType == 'pdb') {
    return 'PDB'
  } else if (blobType == 'pe') {
    return 'PE'
  } else {
    return "Undefined"
  }
}

function abbreviateHash(hash: string): string {
  if (hash.length > 8) {
    return `${hash.slice(0, 4)}...${hash.slice(-4)}`
  } else {
    return hash
  }
}

function timestampToDisplayString(timestamp: string): string {
  return dayjs(timestamp).format('YYYY-MM-DD HH:mm')
}

function copyTextToClipboard(text: string) {
  navigator.clipboard.writeText(text)
}

function getSortIndex(): string | undefined {
  if (options.sortBy.length == 0) {
    return undefined
  } else {
    const sortDirection = (options.sortDesc[0] ? "-" : "")
    const sortKey = options.sortBy[0]
    return `${sortDirection}${sortKey}`
  }
}

async function fetch() {

  try {
    const storeFileBlobsResponse = await api.getStoreFileBlobs(props.store, props.file, getSortIndex(), (options.page - 1) * options.itemsPerPage, options.itemsPerPage)
    storeFileBlobs.value.length = 0
    if (storeFileBlobsResponse.data.blobs) {
      for (const blob of storeFileBlobsResponse.data.blobs) {
        const size = blob.size ?? 0
        storeFileBlobs.value.push({
          blobIdentifier: blob.blobIdentifier,
          uploadTimestamp: blob.uploadTimestamp,
          type: translateBlobType(blob.type),
          size: (size ? size.toString() : "Unknown"),
          contentHash: blob.contentHash ?? "Unknown",
          status: blob.status,
        })
      }
    }
    total.value = storeFileBlobsResponse.data.pagination.total
  } catch (error) {
    console.log(error)
  }
}

function updateOptions(newOptions: DataTableOptions) {
  if ((options.page != newOptions.page)
    || (options.itemsPerPage != newOptions.itemsPerPage)
    || (options.sortBy != newOptions.sortBy)
    || (options.sortDesc != newOptions.sortDesc) ) {
    options = newOptions
    fetch()
  }
}

function downloadFileInBrowser(url: string, filename: string) {

  // This is based on https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/

  // Create a new anchor element
  const a = document.createElement('a')

  // Set the href and download attributes for the anchor element
  // You can optionally set other attributes like `title`, etc
  // Especially, if the anchor element will be attached to the DOM
  a.href = url
  a.download = filename

  // Click handler that removes the anchor element after the element has been clicked
  const clickHandler = () => {
    setTimeout(() => {
      a.remove()
    }, 150)
  };

  // Add the click event listener on the anchor element
  a.addEventListener('click', clickHandler, false)
  
  // Programmatically trigger a click on the anchor element
  a.click()
}

async function download(blobIdentifier: string) {

  try {
    const getStoreFileBlobDownloadUrlResponse = await api.getStoreFileBlobDownloadUrl(props.store, props.file, blobIdentifier)

    downloadFileInBrowser(getStoreFileBlobDownloadUrlResponse.data.url, props.file)
  } catch (error) {
    console.log(error)
  }
}

fetch()


return { __sfc: true,props, headers, options, storeFileBlobs, total, translateBlobType, abbreviateHash, timestampToDisplayString, copyTextToClipboard, getSortIndex, fetch, updateOptions, downloadFileInBrowser, download }
}

})